import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import Accordion from '../ui/accordion';
import Datepicker from '../ui/datepicker';
import Select from '../ui/select';
import Checkbox from '../ui/checkbox';
import Textfield from '../ui/text-field';
import MultiSelect from '../ui/multi-select';
import Rating from '../ui/rating';

import {
    updateReportingDistrict,
    updateReportingRS,
    updateReportingRssOss,
    setEventStatusReport,
    setReportingDateRange,
    resetReportingBtn,
    updateReportingRSSOSSType
} from '../../actions';

import {
    getReportingRegionCodeList,
    getReportingDistrictCodeList,
    getReportingRecruitingStationCodeList,
    getReportingRssOssCodeList,
    getFilterBtnAction
} from '../../reducers';

const makeSearchData = (
    model,
    updateReportingDistrict,
    updateReportingRS,
    updateReportingRssOss,
    updateReportingRSSOSSType,
    reportingRegionCodeList,
    reportingDistrictCodeList,
    reportingRecruitingStationCodeList,
    reportingRssOssCodeList,
    reportingCategoryList,
    setEventStatusReport,
    getFilterBtnAction
) => [
    {
        title: 'Event Status Report',
        content: (
            <Checkbox
                model={`${model}.eventStatusReport[]`}
                options={[
                    {
                        id: 'event-status-report',
                        name: 'Event Status Report',
                        code: 'Event Status Report'
                    }
                ]}
                onChange={setEventStatusReport}
            />
        )
    },
    {
        title: 'Region',
        content: (
            <Select
                model={`${model}.regionCode`}
                changeDefault={'National'}
                onChange={updateReportingDistrict}
                options={reportingRegionCodeList}
            />
        )
    },
    {
        title: 'District',
        content: (
            <Select
                model={`${model}.districtCode`}
                onChange={updateReportingRS}
                options={reportingDistrictCodeList}
            />
        )
    },
    {
        title: 'RS',
        content: (
            <Select
                model={`${model}.recruitingStationCode`}
                onChange={updateReportingRssOss}
                options={reportingRecruitingStationCodeList}
            />
        )
    },
    {
        title: 'RSS/OSS',
        content: (
            <Select
                model={`${model}.rssOssCode`}
                options={reportingRssOssCodeList}
                onChange={updateReportingRSSOSSType}
            />
        )
    },
    {
        title: 'Status',
        content: (
            <div className="form__status">
                <Checkbox
                    model={`${model}.eventStatus[]`}
                    options={[
                        {
                            name: 'Event Creation',
                            code: 'Event Creation'
                        },
                        {
                            name: 'Event Review',
                            code: 'Event Review'
                        }
                    ]}
                />
                <Checkbox
                    model={`${model}.eventReportStatus[]`}
                    options={[
                        {
                            name: 'After Action Pending',
                            code: 'After Action Pending'
                        },
                        {
                            name: 'After Action Incomplete',
                            code: 'After Action Incomplete'
                        },
                        {
                            name: 'After Action Review',
                            code: 'After Action Review'
                        },
                        {
                            name: 'Event/After Action Closed',
                            code: 'Event/After Action Closed'
                        }
                    ]}
                />
            </div>
        )
    },
    {
        title: 'Category',
        content: (
            <MultiSelect
                model={`${model}.category`}
                options={reportingCategoryList}
                resetFilter={getFilterBtnAction}
            />
        )
    },
    {
        title: 'EMV Attended?',
        content: (
            <Select
                model={`${model}.emvAttend`}
                defaultValue={undefined}
                options={[
                    { name: 'Yes', code: 'Yes' },
                    { name: 'No', code: 'No' }
                ]}
            />
        )
    },
    {
        title: 'Event Cost',
        content: (
            <div>
                <Textfield
                    model={`${model}.fromCost`}
                    title="From"
                    type="number"
                />
                <Textfield model={`${model}.toCost`} title="To" type="number" />
            </div>
        )
    },
    {
        title: 'Estimated Attendance',
        content: (
            <Textfield
                model={`${model}.estimatedTargetAttendance`}
                type="number"
                max="200"
            />
        )
    },
    {
        title: 'Lead Cards Submitted',
        content: <Textfield model={`${model}.leadCards`} type="number" />
    },
    {
        title: 'Ratings',
        content: (
            <div>
                <span className="form__title">Target Market Attendance</span>
                <Rating model={`${model}.targetMarketRating`} />

                <span className="form__title">Coming of Age Attendance</span>
                <Rating model={`${model}.comingOfAgeRating`} />

                <span className="form__title">Good Influencer</span>
                <Rating model={`${model}.influentialRating`} />

                <span className="form__title">Community Relations</span>
                <Rating model={`${model}.communityRelationsRating`} />

                <span className="form__title">Lead Generation</span>
                <Rating model={`${model}.leadGenerationRating`} />
            </div>
        )
    },
    {
        title: 'Ethnicity',
        content: (
            <Checkbox
                model={`${model}.ethnicity[]`}
                options={[
                    {
                        name: 'African American',
                        code: 'African American'
                    },
                    {
                        name: 'Asian',
                        code: 'Asian'
                    },
                    {
                        name: 'Caucasian',
                        code: 'Caucasian'
                    },
                    {
                        name: 'Hispanic',
                        code: 'Hispanic'
                    },
                    {
                        name: 'Other',
                        code: 'Other'
                    },
                    {
                        name: 'N/A',
                        code: 'N/A'
                    }
                ]}
            />
        )
    }
];

const mapStateToProps = state => ({
    reportingRegionCodeList: getReportingRegionCodeList(state),
    reportingDistrictCodeList: getReportingDistrictCodeList(state),
    reportingRecruitingStationCodeList: getReportingRecruitingStationCodeList(
        state
    ),
    reportingRssOssCodeList: getReportingRssOssCodeList(state),
    getFilterBtnAction: getFilterBtnAction(state)
});

export default connect(
    mapStateToProps,
    {
        updateReportingDistrict,
        updateReportingRS,
        updateReportingRssOss,
        updateReportingRSSOSSType,
        setEventStatusReport,
        setReportingDateRange,
        resetReportingBtn
    }
)(
    ({
        closeOnClick,
        includeDates = true,
        isActive,
        model,
        showClose = true,
        reportingCategoryList,
        updateReportingDistrict,
        updateReportingRS,
        updateReportingRssOss,
        updateReportingRSSOSSType,
        reportingRegionCodeList,
        reportingDistrictCodeList,
        reportingRecruitingStationCodeList,
        reportingRssOssCodeList,
        setEventStatusReport,
        setReportingDateRange,
        resetReportingBtn,
        getFilterBtnAction
    }) => (
        <section
            className={classnames('panel', `panel--${model}`, {
                'is-active': isActive
            })}
        >
            <div className="panel__inner">
                <div className="panel__actions">
                    <h1 className="panel__heading">Filters</h1>
                    {showClose ? (
                        <button
                            onClick={closeOnClick}
                            className="panel__close-btn"
                            type="button"
                        >
                            <svg className="icon icon-close">
                                <use xlinkHref="#icon-close" />
                            </svg>
                        </button>
                    ) : null}
                </div>

                {includeDates ? (
                    <div onClick={setReportingDateRange}>
                        <Datepicker
                            model={`${model}.startDate`}
                            id="search-date-from"
                            title="From"
                        />

                        <Datepicker
                            model={`${model}.endDate`}
                            id="search-date-to"
                            title="To"
                        />
                    </div>
                ) : null}

                <Accordion
                    data={makeSearchData(
                        model,
                        updateReportingDistrict,
                        updateReportingRS,
                        updateReportingRssOss,
                        updateReportingRSSOSSType,
                        reportingRegionCodeList,
                        reportingDistrictCodeList,
                        reportingRecruitingStationCodeList,
                        reportingRssOssCodeList,
                        reportingCategoryList,
                        setEventStatusReport,
                        getFilterBtnAction
                    )}
                />

                <div className="form__row">
                    <button className="form__submit" type="submit">
                        Apply
                    </button>
                    <button
                        type="button"
                        className="btn btn--reset"
                        onClick={resetReportingBtn}
                    >
                        Reset
                    </button>
                </div>
            </div>
        </section>
    )
);



// WEBPACK FOOTER //
// ./src/components/filtersReporting/index.js